<ng-container *ngIf="(socialEmbedURL || socialEmbedCode) && !noContentToDisplay">
    <div
        class="agpr-socialPostDisplay-socialContainer"
        [ngClass]="'agpr-socialPostDisplay-socialContainer--' + mention.mediaType.id"
        [agprLoading]="!isSocialFrameLoaded"
    >
        <iframe
            *ngIf="socialEmbedURL"
            class="agpr-socialPostDisplay-socialFrame"
            [ngClass]="'agpr-socialPostDisplay-socialFrame--' + mention.mediaType.id"
            [src]="socialEmbedURL | agprBypassURLSecurity"
            (load)="socialFrameLoaded()"
            [title]="iframeTitle"
        ></iframe>
        <iframe
            *ngIf="socialEmbedCode"
            class="agpr-socialPostDisplay-socialFrame"
            [ngClass]="'agpr-socialPostDisplay-socialFrame--' + mention.mediaType.id"
            [srcdoc]="socialEmbedCode"
            (load)="socialFrameLoaded()"
            [title]="iframeTitle"
        ></iframe> 
    </div>
</ng-container>

<ng-container *ngIf="noContentToDisplay">
    <agpr-message
        [style]="componentStyle.social"
        [severity]="messageSeverities.noContent"
    >
        {{ 'Social.post.viewer.noContent' | localize }}
    </agpr-message>
</ng-container>
